import { graphql, useStaticQuery } from 'gatsby';

// This will grab all of the fields in "Settings".
const GetSettings = () => {
  
    // Grab the initial data
    const { settings } = useStaticQuery(graphql`
        {
            settings: allStoryblokEntry(filter: {field_component: {eq: "settings"}}) {
                edges {
                    node {
                    name
                    full_slug
                    content
                    }
                }
            }
        }
    `)
    let content = JSON.parse(settings.edges[0].node.content);
    let parsedSetting = Object.assign({}, content, { content: content });
    return parsedSetting
}

export default GetSettings